import { Component, OnInit } from '@angular/core';
import { UserService } from '@app/user/user.service';
import { GopherService } from '../gopher.service';
import { ToastrService } from 'ngx-toastr';
import { ActivatedRoute, Router } from '@angular/router';
import { resolve } from 'url';

@Component({
  selector: 'app-client',
  templateUrl: './client.component.html',
  styleUrls: ['./client.component.less']
})
export class ClientComponent implements OnInit {


  constructor(private _userService: UserService, private gopherService: GopherService, private toastr: ToastrService,
              private route: ActivatedRoute, private router: Router) { }

  
  id;
  user;
  myProjects;
  showAdd = false;
  clientsList;
  config = {
    'name': null,
    'userName': null,
    'hostAddress': null,
    'server_type': null,
    'clientId': null,
    'project': null
  };

  ngOnInit() {
    this.user = JSON.parse(localStorage.getItem('user'));
    if (!this.user.gopherAdmin) {
      this.router.navigate(['home']);
    }
    this.config.server_type = 'Web Server';
    this.id = parseInt(this.route.snapshot.queryParamMap.get('project'));

    
    if (this.id) {
      this.getProjects().then(projects => {
        this.myProjects = projects;
        projects.forEach(element => {
          if (element.id === this.id) {
            this.config.project = element;
          }
        });
        this.showAdd = true;
        this.getClientsById(this.config.project.id);
      })
    } else {
      this.getProjects();
    }
  }

  getProjects(): Promise<any> {
    return new Promise(resolve => {
      this._userService.getMyProjectList().pipe().subscribe(data => {
        if (data.code === 200) {
          resolve(data.response);
          this.myProjects = data.response;
        }
      });
    });
  }

  cancelAddClients() {
    if (this.config) {
      this.config.name = '';
      this.config.userName = '';
      this.config.hostAddress = '';
      this.showAdd = false;
    }
  }

  saveChaosClients(config) {
    delete config.clientId;
    this.gopherService.save(config).pipe().subscribe(data => {
      if (data.code === 200) {
        this.cancelAddClients();
        this.getClientsById(this.config.project.id);
        this.toastr.success(data.message);
      } else {
        this.toastr.error(data.message);
      }
    });
  }

  getClientsById(id): Promise<any> {
    this.clientsList = null;

    return new Promise(resolve => {
      this.gopherService.getClientsById(id).pipe().subscribe(data => {
        if (data.code === 200) {
          this.clientsList = data.response;
          resolve(data.response);
        }
      });
    });

  }

  syncClient(id) {
    this.gopherService.syncClient(id).pipe().subscribe(data => {
      if (data.code === 200) {
        this.getClientsById(this.config.project.id);
        this.toastr.success(data.message);
      } else {
        this.toastr.error(data.message);
      }
    });
  }

  deleteClient(id, project) {
    this.gopherService.deleteClient(id).pipe().subscribe(data => {
      if (data.code === 200) {
        this.getClientsById(this.config.project.id);
        this.toastr.success(data.message);
      } else {
        this.toastr.error(data.message);
      }
    });
  }
}
